import { render, staticRenderFns } from "./EdModal.vue?vue&type=template&id=08639e48&"
import script from "./EdModal.vue?vue&type=script&lang=js&"
export * from "./EdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports